export default "__VITE_ASSET__f3b8a197__"